const types = {
  RESET_LANDING_PAGE_STATE: 'RESET_LANDING_PAGE_STATE',
  SYNC_LANDING_PAGES: {
    REQUEST: 'SYNC_LANDING_PAGES.REQUEST',
    SUCCESS: 'SYNC_LANDING_PAGES.SUCCESS',
    FAILURE: 'SYNC_LANDING_PAGES.FAILURE',
  },
  SAVE_LANDING_PAGE: {
    REQUEST: 'SAVE_LANDING_PAGE.REQUEST',
    SUCCESS: 'SAVE_LANDING_PAGE.SUCCESS',
    FAILURE: 'SAVE_LANDING_PAGE.FAILURE',
  },
  ARCHIVE_LANDING_PAGE: {
    REQUEST: 'ARCHIVE_LANDING_PAGE.REQUEST',
    SUCCESS: 'ARCHIVE_LANDING_PAGE.SUCCESS',
    FAILURE: 'ARCHIVE_LANDING_PAGE.FAILURE',
  },
};

export default types;
